"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PDFPreview", {
  enumerable: true,
  get: function get() {
    return _PDFPreview["default"];
  }
});
var _PDFPreview = _interopRequireDefault(require("./PDFPreview"));